import { render, staticRenderFns } from "./group-1.vue?vue&type=template&id=2f11a18b&"
import script from "./group-1.vue?vue&type=script&lang=js&"
export * from "./group-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports